import { CircleAlert, RefreshCw } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from './Button'

export interface ErrorStateProps {
  /** What failed, in the console's words: "요청 목록을 불러오지 못했다". */
  title?: string
  /** The error itself, whole — the server's message is the one to look up. */
  error?: unknown
  onRetry?: () => void
  className?: string
}

export function errorText(error: unknown): string {
  if (!error) return ''
  if (error instanceof Error) return error.message
  return String(error)
}

/** A failure shown where it happened, with the raw message and a retry. */
export function ErrorState({ title = '불러오지 못했다', error, onRetry, className }: ErrorStateProps) {
  const text = errorText(error)
  return (
    <div
      role="alert"
      className={cn('rounded-lg border border-status-failed/30 bg-status-failed-soft/60 px-4 py-3', className)}
    >
      <div className="flex items-start gap-2">
        <CircleAlert size={16} className="mt-0.5 shrink-0 text-status-failed" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="text-body font-medium text-status-failed">{title}</p>
          {text && (
            <pre className="mt-1 whitespace-pre-wrap break-words font-mono text-meta text-foreground/80">{text}</pre>
          )}
        </div>
        {onRetry && (
          <Button size="sm" icon={RefreshCw} onClick={onRetry}>
            다시 시도
          </Button>
        )}
      </div>
    </div>
  )
}
